import { Typography, TextField, Grid, Button } from "@material-ui/core";
import { useState } from "react";
import { Autocomplete } from "@material-ui/lab";

const componentInitializer = [
  {
    componentType: "text",
    id: "business_address",
    label: "Business address",
  },
  {
    componentType: "text",
    id: "address_line1",
    label: "Business address line1",
  },

  {
    componentType: "text",
    id: "address_line2",
    label: "Business address line 2",
  },
  {
    componentType: "text",
    id: "city",
    label: "Business City",
  },
  {
    componentType: "text",
    id: "county",
    label: "Business county/state/region",
  },
  {
    componentType: "text",
    id: "zipcode",
    label: "Business post/zip",
  },
  {
    componentType: "dropdown_predictive",
    id: "country_list_id",
    label: "Business country",
    optionsKey: "country_lists",
  },
];

const componentDefiner = (
  componentDetails,
  addressForm,
  setAddressForm,
  dropdownOptions
) => {
  const { componentType, id, optionsKey } = componentDetails;

  switch (componentType) {
    case "text":
      return (
        <TextField
          value={addressForm[id]}
          defaultValue={addressForm[id]}
          onChange={(event) => {
            setAddressForm((prev) => {
              return { ...prev, [id]: event.target.value };
            });
          }}
          key={id}
          fullWidth
          inputProps={{
            style: {
              fontSize: "12px",
              zIndex: "inherit",
              backgroundColor: "#fff",
            },
          }}
        />
      );

    case "dropdown_predictive":
      let inputValue = addressForm[id];

      console.log(inputValue, "input value", addressForm[id]);
      return (
        <Autocomplete
          id={"autoComplete" + id}
          ListboxProps={{
            style: {
              fontSize: "12px",
            },
          }}
          options={dropdownOptions[optionsKey] || []}
          onChange={(event, newValue) => {
            setAddressForm((prev) => {
              return { ...prev, [id]: newValue };
            });
          }}
          getOptionLabel={(option) => option?.value}
          style={{ width: "100%" }}
          value={inputValue}
          defaultValue={inputValue}
          renderInput={(params) => {
            const { inputProps, InputProps, ...otherParams } = params;
            inputProps.style = {
              fontSize: "12px",
            };
            return (
              <TextField
                {...otherParams}
                InputProps={InputProps}
                inputProps={inputProps}
                fullWidth
              />
            );
          }}
        />
      );

    default:
      return "-";
  }
};

const AddressComponent = (props) => {
  const {
    inputValue,
    handleCustomSubmit,
    rowState,
    cell,
    handleClose: handleClosePopup,
  } = props;

  const { id, customComponentKey } = cell.column.columnDef;

  const { dropdowns } = rowState;

  let initialValue = {};

  if (inputValue) {
    if (Array.isArray(inputValue)) {
      initialValue = inputValue[0];
    } else {
      initialValue = inputValue;
    }
    if (typeof initialValue.country_list_id === "object") {
      initialValue.country_list_id = {
        id: initialValue.country_list_id.value,
        value: initialValue.country_list_id.value,
      };
    }
    if (typeof initialValue.country_list_id === "string") {
      initialValue.country_list_id = {
        id: initialValue.country_list_id,
        value: initialValue.country_list_id,
      };
    }
  } else {
    componentInitializer.forEach((el) => {
      initialValue[el.id] = "";
    });
  }
  const [addressForm, setAddressForm] = useState(initialValue);
  console.log(addressForm, "address form");

  const handleSubmit = () => {
    const permittedKeys = componentInitializer.map((el) => {
      return el.id;
    });
    const postValue = [{}];
    permittedKeys.forEach((key) => {
      if (key === "country_list_id") {
        postValue[0][key] = addressForm[key].id;
      } else {
        postValue[0][key] = addressForm[key];
      }
    });
    handleCustomSubmit(id, postValue, customComponentKey);
    handleClosePopup();
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        flexDirection: "column",
        alignItems: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "0.5rem",
          marginBottom: "1rem",
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          style={{ fontSize: "16px", fontWeight: "bold" }}
        >
          Organization address
        </Typography>
      </div>
      <div style={{ width: "100%", flexGrow: 1 }}>
        <Grid container style={{ rowGap: "1rem" }}>
          {componentInitializer.map((component) => {
            return (
              <>
                <Grid
                  item
                  xs={5}
                  style={{ display: "flex", alignItems: "flex-end" }}
                >
                  <Typography variant="subtitle2" style={{ fontSize: "12px" }}>
                    {component.label}
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  {componentDefiner(
                    component,
                    addressForm,
                    setAddressForm,
                    dropdowns
                  )}
                </Grid>
              </>
            );
          })}
        </Grid>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "0.5rem",
          marginBottom: "1rem",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ textTransform: "none" }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};
export default AddressComponent;
